import React from "react"
import { connect } from "react-redux"
import { reduxForm, FieldArray, reset } from "redux-form"
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd"
import Button from "@mui/material/Button"
import withStyles from "@mui/styles/withStyles"
import clsx from "clsx"

import { COLORS } from "../../../../utils"
import SitesAndHubsTabs from "../SitesAndHubsTabs"
import PlanningBrandTabs from "../../../../components/Planning/PlanningBrandTabs"
import DistributionCenterPriorityCard from "../../../OldSettings/Tabs/PlanningSettingsDispatchPriority/DistributionCenterPriorityCard"
import DistributionCenterPriorityListTitle from "../../../OldSettings/Tabs/PlanningSettingsDispatchPriority/DistributionCenterPriorityListTitle"

import {
  planningSettingsDispatchPriorityChangeBrand,
  updateDistributionCentersDispatchPriority,
} from "../../../../actions/Planning/Settings/PlanningSettingsDispatchPriority"

import { distributionCentersPriorityInitialValues } from "../../../../actions/Utils/utils"

const styles = {
  container: {
    width: "100%",
    position: "relative",
    top: 180,
  },
  buttonContainer: {
    margin: 10,
    textAlign: "right",
  },
  button: {
    backgroundColor: COLORS.PRIMARY_COLOR,
  },
}

const SettingsDispatchPriorityTab = ({
  classes,
  handleSubmit,
  menuIsOpen,
  brand,
  planningSettingsDispatchPriorityChangeBrand,
  updateDistributionCentersDispatchPriority,
}) => {
  const onBrandChange = (event, value) => {
    planningSettingsDispatchPriorityChangeBrand(value)
    reset("dispatchPriority")
  }

  const onDragEnd = (event, fields) => {
    if (!event?.source || !event?.destination) return
    fields.move(event.source.index, event.destination.index)
  }

  const renderDistributionCenters = ({ fields }) => (
    <DragDropContext onDragEnd={(event) => onDragEnd(event, fields)}>
      <Droppable droppableId="droppable">
        {(provided) => (
          <div
            {...provided.droppableProps}
            ref={provided.innerRef}
            style={{ height: 72 * fields.length, width: "100%" }}
          >
            {fields.map((_, index) => (
              <Draggable
                key={index}
                draggableId={fields.get(index).objectId}
                index={index}
              >
                {(provided) => (
                  <DistributionCenterPriorityCard
                    name={fields.get(index).name}
                    index={index}
                    provided={provided}
                  />
                )}
              </Draggable>
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  )

  return (
    <SitesAndHubsTabs tabValue="dispatchPriority">
      <PlanningBrandTabs
        tabValue={brand}
        onTabChange={onBrandChange}
        isSub={false}
      />
      <form onSubmit={handleSubmit(updateDistributionCentersDispatchPriority)}>
        <div className={clsx(classes.container, "flexColumn flexEnd")}>
          <DistributionCenterPriorityListTitle menuIsOpen={menuIsOpen} />
          <FieldArray
            name="distributionCenters"
            component={renderDistributionCenters}
          />
          <div className={classes.buttonContainer}>
            <Button type="submit" variant="contained" color="primary">
              Enregistrer
            </Button>
          </div>
        </div>
      </form>
    </SitesAndHubsTabs>
  )
}

const DispatchPriorityForm = reduxForm({
  form: "dispatchPriority",
  enableReinitialize: true,
})(SettingsDispatchPriorityTab)

const StyledForm = withStyles(styles)(DispatchPriorityForm)

export default connect(
  (state) => {
    const brand = state.planningSettings.brand
    const distributionCenters = state.planningSettings.distributionCenters

    return {
      brand,
      menuIsOpen: state.app.menuIsOpen,
      distributionCenters,
      initialValues: distributionCentersPriorityInitialValues(
        distributionCenters,
        brand
      ),
    }
  },
  {
    planningSettingsDispatchPriorityChangeBrand,
    updateDistributionCentersDispatchPriority,
  }
)(StyledForm)
